import React from 'react'
import InputCustom from '../../components/elements/InputCustom'
import SelectDropDown from '../../components/elements/SelectDropDown'
import TextAreaCustom from '../../components/elements/TextAreaCustom'
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang'

function AddFileScriptArchive({page_list_scripts_archive,fields,setFields}) {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const handleFieldChange = (index, field, value) => {
        const newFields = [...fields]
        newFields[index][field] = value
        setFields(newFields)
    }

    const addField = () => {
        const newFields = [...fields, { file_path: '', notes: '' }]
        setFields(newFields)
    }

    const removeField = (index) => {
        const newFields = [...fields]
        newFields.splice(index, 1)
        setFields(newFields)
    }
    return (
        <>
            {fields.map((field, index) => (
                <div key={index}>
                    <div className='d-flex' >
                        <div style={{ width: "48%" }} >
                            <InputCustom
                                label='file'
                                iconType='pencil' value={field.file_path}
                                type='file' service_name='SCRIPTS'
                                onChange={handleFieldChange}
                                index={index}
                            />
                        </div>
                        <div className='one-select' style={{ width: "48%" }}  >
                            <span>{translate('type')}</span>
                            <SelectDropDown
                                options={page_list_scripts_archive?.file_types?.map((file)=>({
                                    label: file, value: file
                                }))}
                                varr={fields[index].type}
                                setVarr={(e) => handleFieldChange(index, 'type', e)}
                            />
                        </div>
                        {
                            index === 0 && (
                                <i className='fa fa-plus plus-arr' onClick={addField} ></i>
                            )
                        }
                        {
                            index > 0 && (
                                <i className='fa fa-minus minus-arr' onClick={() => removeField(index)} ></i>
                            )
                        }
                    </div>
                    <div className='d-flex' >
                        <div className='one-text-area' style={{ width: '48%' }}>
                            <TextAreaCustom
                                label='notes'
                                onChange={(e) => handleFieldChange(index, 'notes', e.target.value)}
                                nameClass='textarea-gen'
                            />
                        </div>
                        <div className='one-text-area' style={{ width: '48%' }}>
                            <TextAreaCustom
                                label='description'
                                onChange={(e) => handleFieldChange(index, 'descrptions', e.target.value)}
                                nameClass='textarea-gen'
                            />
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}

export default AddFileScriptArchive